import type { TranslationMessages } from '../types';

export const ingredients: TranslationMessages = {
  name: 'Quản lý nguyên liệu',
  add: 'Thêm nguyên liệu',
  edit: 'Chỉnh sửa nguyên liệu',
  create: 'Tạo nguyên liệu',
  list: 'Nguyên liệu',
  search: 'Tìm kiếm nguyên liệu...',
  empty: 'Không tìm thấy nguyên liệu',
  delete: {
    title: 'Xóa nguyên liệu',
    confirm:
      'Bạn có chắc chắn muốn xóa nguyên liệu này? Hành động này không thể hoàn tác.',
  },
  fields: {
    name: 'Tên',
    description: 'Mô tả',
    imageId: 'Hình ảnh',
    recipeId: 'Công thức (Tùy chọn)',
    recipe: 'Công thức',
  },
  recipe: {
    none: 'Không có công thức',
    hasRecipe: 'Có công thức',
    help: 'Nếu nguyên liệu này được tạo từ các nguyên liệu khác, hãy chọn một công thức. Điều này cho phép công thức lồng nhau tối đa 2 cấp.',
  },
  placeholders: {
    selectRecipe: 'Chọn công thức',
    searchRecipe: 'Tìm kiếm công thức...',
  },
};
